"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAvatarDto = instanceOfAvatarDto;
exports.AvatarDtoFromJSON = AvatarDtoFromJSON;
exports.AvatarDtoFromJSONTyped = AvatarDtoFromJSONTyped;
exports.AvatarDtoToJSON = AvatarDtoToJSON;
exports.AvatarDtoToJSONTyped = AvatarDtoToJSONTyped;
/**
 * Check if a given object implements the AvatarDto interface.
 */
function instanceOfAvatarDto(value) {
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    return true;
}
function AvatarDtoFromJSON(json) {
    return AvatarDtoFromJSONTyped(json, false);
}
function AvatarDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'avatar': json['avatar'],
    };
}
function AvatarDtoToJSON(json) {
    return AvatarDtoToJSONTyped(json, false);
}
function AvatarDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'avatar': value['avatar'],
    };
}
//# sourceMappingURL=AvatarDto.js.map